<template>
    <div v-if="loading" class="loading">
        <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
    </div>
</template>

<script>
export default {
    props: ['loading'],
}
</script>
